import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import AddItemRow from './AddItemRow';
import { v4 } from 'uuid';
import { DEFAULT_ROW_VALUES } from '@app/components/pages/checkout/shopping-cart/ShoppingCartPage/constants';

const AddItemRows = ({ defaultRows, maxRows, push, remove, ...props }) => {
  const { values } = useFormikContext();

  const numRows = values.items?.length;

  const addRow = (rowNum, data = DEFAULT_ROW_VALUES) => {
    if (rowNum < maxRows) {
      push({ ...data, id: v4() });
    }
  };

  return values.items?.length
    ? values.items?.map((item, index) => (
        <AddItemRow
          addRow={addRow}
          deleteRow={remove}
          isDefaultRow={index < defaultRows}
          isLast={index + 1 === numRows}
          key={item.id}
          maxRows={maxRows}
          numRows={numRows}
          rowNum={index}
          showNotes={values.showNotes}
          {...props}
        />
      ))
    : null;
};

export default AddItemRows;

AddItemRows.propTypes = {
  defaultRows: PropTypes.number,
  maxRows: PropTypes.number,
  push: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired
};
